import { FC } from 'react';

interface CourseAimsProps {
  goals: Array<{ id: number; text: string }>;
}

export const CourseAims: FC<CourseAimsProps> = ({ goals }) => {
  return (
    <div className="flex min-w-0 flex-col gap-3">
      <h5 className="[font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h5)]! text-(--neutral-black-NB1000)! font-bold m-0!">
        Goals
      </h5>

      <ul className="m-0! flex flex-col gap-2 p-0!">
        {goals.map((goal) => (
          <li
            key={goal.id}
            className="flex min-w-0 items-center gap-3 [font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! leading-[125%] text-(--neutral-black-NB900)!"
          >
            <span className="h-2.5 w-2.5 shrink-0 bg-(--secondary-B200)" />
            <span className="min-w-0">{goal.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
